import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useAuth } from "@/hooks/useAuth";

interface ConnectionCounts {
  [key: string]: number;
}

export const useAdminConnectionCounts = () => {
  const { profile } = useAuth();
  const [counts, setCounts] = useState<ConnectionCounts>({});

  useEffect(() => {
    if (!profile?.client_id) return;

    const fetchCounts = async () => {
      const clientId = profile.client_id;
      const results: ConnectionCounts = {};

      const [
        { count: uploads },
        { count: gmail },
        { count: drive },
        { count: scripts },
        { count: mcpServers },
        { count: sqlDb },
        { count: telegram },
        { count: whatsapp },
      ] = await Promise.all([
        supabase.from("manual_upload").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("gmail_tokens").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("google_drive_tokens").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("scripts").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("data_sources").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("pipeline_source_connector").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("telegram_connections").select("*", { count: "exact", head: true }).eq("client_id", clientId),
        supabase.from("whatsapp_connections").select("*", { count: "exact", head: true }).eq("client_id", clientId),
      ]);

      if (uploads) results["ds-manual-uploads"] = uploads;
      if (gmail) results["ds-gmail"] = gmail;
      if (drive) results["ds-google-drive"] = drive;
      if (scripts) results["ds-scripts"] = scripts;
      if (mcpServers) results["ds-mcp-servers"] = mcpServers;
      if (sqlDb) results["ds-sql-db"] = sqlDb;
      if (telegram) results["telegram"] = telegram;
      if (whatsapp) results["whatsapp"] = whatsapp;

      setCounts(results);
    };

    fetchCounts();
  }, [profile?.client_id]);

  return counts;
};
